module.exports = __webpack_public_path__ + "img/11.d6d3709f.jpg";